import { Injectable } from '@angular/core';
import { VimeoEmbedded, VimeoService } from '@epicuro-next/data/vimeo';
import { Observable } from 'rxjs';

@Injectable()
export class VimeoFeatureService {
  constructor(private vimeoService: VimeoService) {}

  public getoEmbedVideo(url: string): Observable<VimeoEmbedded> {
    return this.vimeoService.getoEmbedVideo(url);
  }

  public getLiveChatUrl(url: string): string {
    return this.vimeoService.getLiveChatUrl(url);
  }
}
